@import (reference) '../../../../../../constants/spacing.module.less';

.pickup-address-checkbox {
  align-items: center;
  height: 24px;
  padding: 0 @space-16;
  margin-bottom: @space-16;
}

.prompt {
  font-size: 14px;
  padding-bottom: 0;
  margin-bottom: 0;
}

.info-icon {
  margin-top: @space-4;
  color: var(--gray-637381);
}
